import { useState } from 'react';
import { Chip } from '@mui/material';
import { budgets } from './monthly-budget-edit-dialog/bugets';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { MonthlyBudgetEditDialog } from '@/packages/my-profile/components/preferences-section/components/monthly-budget/monthly-budget-edit-dialog';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const MonthlyBudget = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const maxBudgetPerMonth = profile?.max_budget_per_month || null;

  const handleSaveMonthlyBudget = (value: string | null) => {
    updateProfile({
      profile: {
        ...profile,
        max_budget_per_month: value,
        ...(value === null && { min_budget_per_month: '0.0' }),
      },
    });
  };

  const budgetLabel = budgets.find(
    (budget) => budget.value === maxBudgetPerMonth
  )?.label;

  return (
    <>
      <ProfileItem
        title="Orçamento mensal"
        onClick={() => setIsDialogOpen(true)}
      >
        {budgetLabel && <Chip key={budgetLabel} label={budgetLabel} />}
      </ProfileItem>
      {isDialogOpen && profile && (
        <MonthlyBudgetEditDialog
          currentValue={maxBudgetPerMonth}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSaveMonthlyBudget}
        />
      )}
    </>
  );
};
